<button
  [class.button--dashed]="type === 'dashed'"
  [class.button--light]="type === 'light'"
  [class.button--full-width]="fullWidth"
  [disabled]="isDisabled"
  [type]="isSubmit ? 'submit' : 'button'"
  class="button"
>
  <ng-content></ng-content>
  <img *ngIf="type === 'default'" alt="arrow right icon" src="assets/icons/arrow-right-light.svg" />
  <img *ngIf="type === 'light'" alt="arrow right icon" src="assets/icons/arrow-right-purple.svg" />
</button>
